import http from "@/api/api";
import * as format from "@/utils/format.js";



//查询全部AI应用
export const getAiList = async (val) => {
  let res = await http.get("/tenant/application/list",val);
  return res;
};

